/* global activeFiltersTranslation */
/* global lessTranslation */
/* global moreTranslation */
/* global countVisibleFilters */
/* global foundProducts */
/* global invalidToken */
/* global warningCart */

import TCAIQuickView from "./quickview";
import TCAISearch from "./script";

const TCAIFilters = {

    initialization: function () {
        this.showBrandsAjax();
        this.priceRangesAjax();
        this.showColorsAjax();
        this.showFiltersAjax();
        this.addFiltersAjax();
        this.closeSelectedFilter();
        this.blockMobileFilter();
        this.showMobileFilter();
        this.clearFiltersAjax();
    },

    addFiltersAjax: function (element = document) {
        if (!element) {
            return
        }

        const listSelectedFilters = document.querySelector('[class^="tcai_selected-filters"]');
        const filterMinPrice = element.querySelector('#filter-min-price');
        const filterMaxPrice = element.querySelector('#filter-max-price');
        const filterBrandsColors = element.querySelectorAll('.brand, .tcai-color');
        const attributeFilters = element.querySelectorAll('.tcai-filter');

        if (!listSelectedFilters) {
            return
        }

        const prices = [filterMinPrice, filterMaxPrice];

        prices.forEach((price) => {
            if (price !== null) {
                price.addEventListener('change', () => {
                    const minPrice = parseInt(filterMinPrice.value).toLocaleString('pl-PL') + ' ' + filterMinPrice.getAttribute('data-currency');
                    const maxPrice = parseInt(filterMaxPrice.value).toLocaleString('pl-Pl') + ' ' + filterMaxPrice.getAttribute('data-currency');

                    const newSelectedFilter = document.createElement('div');
                    newSelectedFilter.classList.add('selected-filter');
                    newSelectedFilter.classList.add('selected-filter-price');
                    newSelectedFilter.setAttribute('data-type', filterMinPrice.getAttribute('data-type'));
                    newSelectedFilter.innerHTML = filterMinPrice.getAttribute('data-type-translation') + ': ' + minPrice + ' - ' + maxPrice + ' <span class="selected-filter-close">x</span>';

                    TCAIFilters.closeSelectedFilter(newSelectedFilter.querySelectorAll('.selected-filter-close'));

                    if (listSelectedFilters.querySelectorAll('div').length === 0) {
                        const selectedFilterText = document.createElement('div');
                        selectedFilterText.classList.add('selected-filter-text');
                        selectedFilterText.innerText = activeFiltersTranslation;
                        listSelectedFilters.appendChild(selectedFilterText);

                        listSelectedFilters.classList.remove('tcai_selected-filters');
                        listSelectedFilters.classList.add('tcai_selected-filters-show');
                    }

                    if (document.querySelectorAll('.selected-filter-price').length === 0) {
                        listSelectedFilters.appendChild(newSelectedFilter);
                    } else {
                        document.querySelectorAll('.selected-filter-price')[0].remove();
                        listSelectedFilters.appendChild(newSelectedFilter);
                    }

                    TCAIFilters.filter();
                });
            }
        });

        filterBrandsColors.forEach((filterBrandColor) => {
            filterBrandColor.addEventListener('click', () => {
                const inputCheckbox = filterBrandColor.querySelector('input[type="checkbox"]');

                if (!inputCheckbox) {
                    return
                }

                if (!inputCheckbox.getAttribute('checked')) {
                    inputCheckbox.setAttribute('checked', false);

                    const newSelectedFilter = document.createElement('div');
                    newSelectedFilter.classList.add('selected-filter');
                    newSelectedFilter.setAttribute('data-name', inputCheckbox.getAttribute('data-name'));
                    newSelectedFilter.setAttribute('data-type', inputCheckbox.getAttribute('data-type'));
                    newSelectedFilter.setAttribute('data-id-group', inputCheckbox.getAttribute('data-id-group'));
                    newSelectedFilter.setAttribute('data-id-attribute', inputCheckbox.getAttribute('data-id-attribute'));
                    newSelectedFilter.innerHTML = inputCheckbox.getAttribute('data-type-translation') + ': ' + inputCheckbox.getAttribute('data-name') + ' <span class="selected-filter-close">x</span>';

                    TCAIFilters.closeSelectedFilter(newSelectedFilter.querySelectorAll('.selected-filter-close'));

                    if (listSelectedFilters.querySelectorAll('div').length === 0) {
                        const selectedFilterText = document.createElement('div');
                        selectedFilterText.classList.add('selected-filter-text');
                        selectedFilterText.innerText = activeFiltersTranslation;
                        listSelectedFilters.appendChild(selectedFilterText);

                        listSelectedFilters.classList.remove('tcai_selected-filters');
                        listSelectedFilters.classList.add('tcai_selected-filters-show');
                    }

                    listSelectedFilters.appendChild(newSelectedFilter);

                    if (inputCheckbox.getAttribute('data-type') === 'Color') {
                        inputCheckbox.parentNode.querySelector('span').classList.add('color-selected');
                    }
                } else {
                    inputCheckbox.removeAttribute('checked');

                    listSelectedFilters.removeChild(listSelectedFilters.querySelector('div[data-name="' + inputCheckbox.getAttribute('data-name') + '"]'));

                    if (listSelectedFilters.querySelectorAll('div').length === 1) {
                        listSelectedFilters.querySelectorAll('div')[0].remove();

                        listSelectedFilters.classList.remove('tcai_selected-filters-show');
                        listSelectedFilters.classList.add('tcai_selected-filters');
                    }

                    if (inputCheckbox.getAttribute('data-type') === 'Color') {
                        inputCheckbox.parentNode.querySelector('span').classList.remove('color-selected');
                    }
                }

                TCAIFilters.filter();
            });
        });

        attributeFilters.forEach((attributeFilter) => {
            attributeFilter.addEventListener('click', () => {
                const inputCheckbox = attributeFilter.querySelector('input[type="checkbox"]');

                if (!inputCheckbox) {
                    return
                }

                if (!inputCheckbox.getAttribute('checked')) {
                    inputCheckbox.setAttribute('checked', false);

                    const newSelectedFilter = document.createElement('div');
                    newSelectedFilter.classList.add('selected-filter');
                    newSelectedFilter.setAttribute('data-name', inputCheckbox.getAttribute('data-name'));
                    newSelectedFilter.setAttribute('data-type', inputCheckbox.getAttribute('data-type'));
                    newSelectedFilter.setAttribute('data-id-attribute', inputCheckbox.getAttribute('data-id-attribute'));
                    newSelectedFilter.setAttribute('data-id-group', inputCheckbox.getAttribute('data-id-group'));
                    newSelectedFilter.innerHTML = inputCheckbox.getAttribute('data-type-translation') + ': ' + inputCheckbox.getAttribute('data-name') + ' <span class="selected-filter-close">x</span>';

                    TCAIFilters.closeSelectedFilter(newSelectedFilter.querySelectorAll('.selected-filter-close'));

                    if (listSelectedFilters.querySelectorAll('div').length === 0) {
                        const selectedFilterText = document.createElement('div');
                        selectedFilterText.classList.add('selected-filter-text');
                        selectedFilterText.innerText = activeFiltersTranslation;
                        listSelectedFilters.appendChild(selectedFilterText);

                        listSelectedFilters.classList.remove('tcai_selected-filters');
                        listSelectedFilters.classList.add('tcai_selected-filters-show');
                    }

                    listSelectedFilters.appendChild(newSelectedFilter);

                    if (inputCheckbox.getAttribute('data-type') === 'Color') {
                        inputCheckbox.parentNode.querySelector('span').classList.add('color-selected');
                    }
                } else {
                    inputCheckbox.removeAttribute('checked');

                    listSelectedFilters.removeChild(listSelectedFilters.querySelector('div[data-name="' + inputCheckbox.getAttribute('data-name') + '"]'));

                    if (listSelectedFilters.querySelectorAll('div').length === 1) {
                        listSelectedFilters.querySelectorAll('div')[0].remove();

                        listSelectedFilters.classList.remove('tcai_selected-filters-show');
                        listSelectedFilters.classList.add('tcai_selected-filters');
                    }

                    if (inputCheckbox.getAttribute('data-type') === 'Color') {
                        inputCheckbox.parentNode.querySelector('span').classList.remove('color-selected');
                    }
                }

                TCAIFilters.filter();
            });
        });
    },

    selectedFilters: function () {
        const filters = document.querySelectorAll('div.brand, div.tcai-color');
        const priceFilters = document.querySelectorAll('.prices-range-input input');
        const listSelectedFilters = document.querySelector('[class^="tcai_selected-filters"]');

        if (!filters || !listSelectedFilters || !priceFilters) {
            return
        }

        priceFilters.forEach((priceFilter) => {
            priceFilter.addEventListener('change', () => {
                const minPriceInput = document.querySelector('#filter-min-price');
                const maxPriceInput = document.querySelector('#filter-max-price');

                if (!minPriceInput || !maxPriceInput) {
                    return
                }

                let minPrice = parseInt(minPriceInput.value).toLocaleString('pl-PL') + ' ' + priceFilter.getAttribute('data-currency');
                let maxPrice = parseInt(maxPriceInput.value).toLocaleString('pl-Pl') + ' ' + priceFilter.getAttribute('data-currency');

                const newSelectedFilter = document.createElement('div');
                newSelectedFilter.classList.add('selected-filter');
                newSelectedFilter.classList.add('selected-filter-price');
                newSelectedFilter.innerHTML = priceFilter.getAttribute('data-type') + ': ' + minPrice + ' - ' + maxPrice + ' <span class="selected-filter-close">x</span>';

                TCAIFilters.closeSelectedFilter(newSelectedFilter.querySelectorAll('.selected-filter-close'));

                if (listSelectedFilters.querySelectorAll('div').length === 0) {
                    const selectedFilterText = document.createElement('div');
                    selectedFilterText.classList.add('selected-filter-text');
                    selectedFilterText.innerText = activeFiltersTranslation;
                    listSelectedFilters.appendChild(selectedFilterText);

                    listSelectedFilters.classList.remove('tcai_selected-filters');
                    listSelectedFilters.classList.add('tcai_selected-filters-show');
                }

                if (document.querySelectorAll('.selected-filter-price').length === 0) {
                    listSelectedFilters.appendChild(newSelectedFilter);
                } else {
                    document.querySelectorAll('.selected-filter-price')[0].remove();
                    listSelectedFilters.appendChild(newSelectedFilter);
                }

                TCAIFilters.filter();
            });

        });

        filters.forEach((filter) => {
            filter.addEventListener('click', () => {
                const inputCheckbox = filter.querySelector('input[type="checkbox"]');

                if (!inputCheckbox) {
                    return
                }

                if (!inputCheckbox.getAttribute('checked')) {
                    inputCheckbox.setAttribute('checked', false);

                    const newSelectedFilter = document.createElement('div');
                    newSelectedFilter.classList.add('selected-filter');
                    newSelectedFilter.setAttribute('data-name', inputCheckbox.getAttribute('data-name'));
                    newSelectedFilter.setAttribute('data-type', inputCheckbox.getAttribute('data-type'));
                    newSelectedFilter.setAttribute('data-id-attribute', inputCheckbox.getAttribute('data-id-attribute'));
                    newSelectedFilter.innerHTML = inputCheckbox.getAttribute('data-type-translation') + ': ' + inputCheckbox.getAttribute('data-name') + ' <span class="selected-filter-close">x</span>';

                    TCAIFilters.closeSelectedFilter(newSelectedFilter.querySelectorAll('.selected-filter-close'));

                    if (listSelectedFilters.querySelectorAll('div').length === 0) {
                        const selectedFilterText = document.createElement('div');
                        selectedFilterText.classList.add('selected-filter-text');
                        selectedFilterText.innerText = activeFiltersTranslation;
                        listSelectedFilters.appendChild(selectedFilterText);

                        listSelectedFilters.classList.remove('tcai_selected-filters');
                        listSelectedFilters.classList.add('tcai_selected-filters-show');
                    }

                    listSelectedFilters.appendChild(newSelectedFilter);

                    if (inputCheckbox.getAttribute('data-type') === 'Color') {
                        inputCheckbox.parentNode.querySelector('span').classList.add('color-selected');
                    }

                    TCAIFilters.filter();
                } else {
                    inputCheckbox.removeAttribute('checked');

                    listSelectedFilters.removeChild(listSelectedFilters.querySelector('div[data-name="' + inputCheckbox.getAttribute('data-name') + '"]'));

                    if (listSelectedFilters.querySelectorAll('div').length === 1) {
                        listSelectedFilters.querySelectorAll('div')[0].remove();

                        listSelectedFilters.classList.remove('tcai_selected-filters-show');
                        listSelectedFilters.classList.add('tcai_selected-filters');
                    }

                    if (inputCheckbox.getAttribute('data-type') === 'Color') {
                        inputCheckbox.parentNode.querySelector('span').classList.remove('color-selected');
                    }

                    TCAIFilters.filter();
                }
            });
        });
    },

    closeSelectedFilter: function (element = document.querySelectorAll('.selected-filter-close')) {
        element.forEach((closeFilter) => {
            closeFilter.addEventListener('click', function () {
                if (closeFilter.parentNode.getAttribute('data-type') === 'Price') {
                    const minPrice = document.querySelector('#filter-min-price');
                    const maxPrice = document.querySelector('#filter-max-price');
                    const minPriceSpan = document.querySelector('.min-price-selected');
                    const maxPriceSpan = document.querySelector('.max-price-selected');
                    const filterChangedPrice = document.querySelector('#filter-changed-price');

                    if (!minPrice || !maxPrice || !minPriceSpan || !maxPriceSpan || !filterChangedPrice) {
                        return
                    }

                    minPrice.value = minPrice.min;
                    maxPrice.value = maxPrice.max;
                    minPriceSpan.innerText = minPrice.min;
                    maxPriceSpan.innerText = maxPrice.max;
                    minPrice.setAttribute('deleted', 'true');
                    filterChangedPrice.value = 0;

                } else if (closeFilter.parentNode.getAttribute('data-type') === 'Brand') {
                    let unselectedBrand = closeFilter.parentNode.getAttribute('data-name');
                    document.querySelector('input[type="checkbox"][data-type="Brand"][data-name="' + unselectedBrand + '"]').checked = false;
                } else if (closeFilter.parentNode.getAttribute('data-type') === 'Color') {
                    let unselectedColor = closeFilter.parentNode.getAttribute('data-id-attribute');
                    document.querySelector('input[type="checkbox"][data-type="Color"][data-id-attribute="' + unselectedColor + '"]').parentNode.querySelector('span').classList.remove('color-selected')
                }

                closeFilter.parentElement.remove();

                const listSelectedFilters = document.querySelector('[class^="tcai_selected-filters"]');

                if (!listSelectedFilters) {
                    return
                }

                if (listSelectedFilters.querySelectorAll('div').length === 1) {
                    listSelectedFilters.querySelectorAll('div')[0].remove();

                    listSelectedFilters.classList.remove('tcai_selected-filters-show');
                    listSelectedFilters.classList.add('tcai_selected-filters');
                }

                TCAIFilters.filter();
            });
        });
    },

    showBrandsAjax: function (element = document.querySelector('.more-brand')) {
        if (!element) {
            return
        }

        element.addEventListener('click', function () {
            const brands = element.parentNode.querySelectorAll('.brand');

            if (element.getAttribute('data-operation') === 'more') {
                brands.forEach((brand) => {
                    brand.style.display = 'block';
                });

                element.innerText = lessTranslation;
                element.setAttribute('data-operation', 'less');
            } else if (element.getAttribute('data-operation') === 'less') {
                brands.forEach((brand, i) => {
                    if (i > 6) {
                        brand.style.display = 'none';
                    }
                });

                element.innerText = moreTranslation;
                element.setAttribute('data-operation', 'more');
            }
        });
    },

    priceRangesAjax: function (element = document.querySelectorAll('.prices-range-input input')) {
        if (!element) {
            return
        }

        element.forEach((priceInput) => {
            priceInput.addEventListener('input', function () {
                const rangePricesInput = priceInput.parentNode.querySelectorAll('input');
                const rangePriceMin = priceInput.parentNode.parentNode.parentNode.querySelector('.min-price-selected');
                const rangePriceMax = priceInput.parentNode.parentNode.parentNode.querySelector('.max-price-selected');
                const priceChanged = document.getElementById('filter-changed-price');

                if (!rangePricesInput && !rangePriceMin && !rangePriceMax && rangePricesInput.length < 2 && !priceChanged) {
                    return
                }

                let min = parseInt(rangePricesInput[0].value);
                let max = parseInt(rangePricesInput[1].value);

                rangePricesInput[0].setAttribute('data-selected', 'true');
                rangePricesInput[1].setAttribute('data-selected', 'true');

                if (max - min <= 0) {
                    rangePricesInput[1].value = min;
                    max = min;
                }

                rangePriceMin.innerHTML = min;
                rangePriceMax.innerHTML = max;
                priceChanged.value = 1;
            });
        });
    },

    showColorsAjax: function (element = document.querySelector('.more-color')) {
        if (!element) {
            return
        }

        element.addEventListener('click', function () {
            const colors = element.parentNode.querySelectorAll('.tcai-color');

            if (element.getAttribute('data-operation') === 'more') {

                colors.forEach((color) => {
                    color.style.display = 'inherit';
                });

                element.innerText = lessTranslation;
                element.setAttribute('data-operation', 'less');
            } else if (element.getAttribute('data-operation') === 'less') {

                colors.forEach((color, i) => {
                    if (i > 6) {
                        color.style.display = 'none';
                    }
                });

                element.innerText = moreTranslation;
                element.setAttribute('data-operation', 'more');
            }
        });
    },

    showFiltersAjax: function (elements = document.querySelectorAll('.more-tcai-filter')) {
        if (!elements) {
            return
        }

        elements.forEach((element) => {
            element.addEventListener('click', function () {
                const filters = element.parentNode.querySelectorAll('.tcai-filter');

                if (element.getAttribute('data-operation') === 'more') {

                    filters.forEach((filter) => {
                        filter.style.display = 'inherit';
                    });

                    element.innerText = lessTranslation;
                    element.setAttribute('data-operation', 'less');
                } else if (element.getAttribute('data-operation') === 'less') {

                    filters.forEach((filter, i) => {
                        if (i > parseInt(countVisibleFilters) - 1) {
                            filter.style.display = 'none';
                        }
                    });

                    element.innerText = moreTranslation;
                    element.setAttribute('data-operation', 'more');
                }
            });
        });
    },

    clearFiltersAjax: function (element = document.querySelector('.tcai-clear-filter')) {
        if (!element) {
            return
        }

        element.addEventListener('click', () => {
            const urlParameters = new URLSearchParams(window.location.search);
            const inputToken = document.getElementById('tcai_filter_input_token');

            if (!inputToken) {
                return
            }

            if (urlParameters.get('query').length > 0) {
                const formData = new FormData();
                formData.append('search_query', urlParameters.get('query'));
                formData.append('token', inputToken.value);

                fetch('/module/tcai_presta_plugin/clearfilters', {
                    method: 'POST', body: formData,
                }).then(response => response.json())
                    .then((data) => {
                        if (data.success === true) {
                            window.location.href = window.location.pathname + '?query=' + urlParameters.get('query');
                        } else {
                            TCAISearch.displayNotification(warningCart, data.message);
                        }
                    });
            }
        });
    },

    showMobileFilter: function (element = document.querySelector('.mobile-filter')) {
        if (!element) {
            return
        }

        element.addEventListener('click', () => {
            const filters = document.querySelector('.tcai_results .filters');

            if (!filters) {
                return
            }

            if (filters.style.display === 'block') {
                filters.style.display = 'none';
            } else {
                filters.style.display = 'block';
            }
        });
    },

    blockMobileFilter: function (element = document.querySelector('.mobile-filter')) {
        if (!element) {
            return
        }

        element.addEventListener('mousedown', (e) => {
            e.preventDefault();
        });
    },

    filter: function () {
        const urlParameters = new URLSearchParams(window.location.search);
        const selectedFilters = document.querySelectorAll('.selected-filter');
        const productsDiv = document.querySelector('.tcai_products');
        const paginationDiv = document.querySelector('.tcai_results_pagination');
        const countFoundProducts = document.querySelector('.count-found-products');
        const filtersDiv = document.querySelector('.filters');
        const filters = {};
        const inputToken = document.getElementById('tcai_filter_input_token');

        if (!inputToken) {
            return
        }

        selectedFilters.forEach((selectedFilter) => {
            if (!selectedFilter.classList.contains('selected-filter-price')) {
                if (!Object.prototype.hasOwnProperty.call(filters, selectedFilter.getAttribute('data-type'))) {
                    if (selectedFilter.getAttribute('data-type') === 'Brand' || selectedFilter.getAttribute('data-type') === 'Sorting') {
                        filters[selectedFilter.getAttribute('data-type')] = [selectedFilter.getAttribute('data-name')];
                    } else {
                        if (!Object.prototype.hasOwnProperty.call(filters, selectedFilter.getAttribute('data-id-group'))) {
                            filters[selectedFilter.getAttribute('data-id-group')] = [selectedFilter.getAttribute('data-id-attribute')];
                        } else {
                            filters[selectedFilter.getAttribute('data-id-group')].push(selectedFilter.getAttribute('data-id-attribute'));
                        }
                    }
                } else {
                    if (selectedFilter.getAttribute('data-type') === 'Brand' || selectedFilter.getAttribute('data-type') === 'Sorting') {
                        filters[selectedFilter.getAttribute('data-type')].push(selectedFilter.getAttribute('data-name'));
                    } else {
                        filters[selectedFilter.getAttribute('data-id-group')].push(selectedFilter.getAttribute('data-id-attribute'));
                    }
                }
            }
        });

        const minPrice = document.querySelector('#filter-min-price');
        const maxPrice = document.querySelector('#filter-max-price');
        const priceChanged = document.getElementById('filter-changed-price');

        if (minPrice !== null && maxPrice !== null && priceChanged !== null && parseInt(priceChanged.value) === 1) {
            filters['Price'] = [parseInt(minPrice.value), parseInt(maxPrice.value)];
        }

        productsDiv.style.opacity = 0.2;

        const formData = new FormData();
        formData.append('search_query', urlParameters.get('query'));
        formData.append('filters', JSON.stringify(filters));
        formData.append('token', inputToken.value);

        if (urlParameters.get('brand') !== null) {
            formData.append('brand', urlParameters.get('brand'));
        }
        if (urlParameters.get('category') !== null) {
            formData.append('category', urlParameters.get('category'));
        }

        fetch('/module/tcai_presta_plugin/resultsfilter', {
            method: 'POST', body: formData,
        }).then(response => response.json())
            .then(ajaxResponse => {
                if (ajaxResponse.success === true && Object.prototype.hasOwnProperty.call(ajaxResponse, 'products')) {
                    const filterArea = document.querySelector('[class^="tcai_selected-filters"]')
                    document.querySelectorAll('.tcai_product').forEach((product) => product.remove());

                    productsDiv.removeAttribute('style');

                    if (filterArea) {
                        productsDiv.innerHTML = ajaxResponse.products;
                        if (ajaxResponse.count) {
                            countFoundProducts.innerHTML = foundProducts + ' <span>' + ajaxResponse.count + '</span>';
                        }
                        filtersDiv.innerHTML = ajaxResponse.filters;

                        TCAIFilters.addFiltersAjax(filtersDiv);
                        TCAIFilters.showBrandsAjax(filtersDiv.querySelector('.more-brand'));
                        TCAIFilters.priceRangesAjax(filtersDiv.querySelectorAll('.prices-range-input input'));
                        TCAIFilters.showColorsAjax(filtersDiv.querySelector('.more-color'));
                        TCAIFilters.clearFiltersAjax(filtersDiv.querySelector('.tcai-clear-filter'));
                        TCAIQuickView.quickView();

                        if (paginationDiv) {
                            paginationDiv.remove();
                        }
                    }
                } else {
                    productsDiv.style.opacity = 1;
                    productsDiv.innerHTML = '<p>' + invalidToken + '</p>';
                }
            });
    }
}

export default TCAIFilters;